var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 224,
    viewBox: "0 0 228 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1598_392)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1598_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.366 39.5059H53.2809C44.3658 39.5059 37.1387 46.7369 37.1387 55.6568V198.996C37.1387 207.916 44.3658 215.147 53.2809 215.147H176.366C185.28 215.147 192.508 207.916 192.508 198.996V55.6568C192.508 46.7369 185.28 39.5059 176.366 39.5059Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.44 91.6387H27.9143C25.8765 91.6387 24.2246 93.29 24.2246 95.327V101.782C24.2246 103.819 25.8765 105.47 27.9143 105.47H152.44C154.478 105.47 156.13 103.819 156.13 101.782V95.327C156.13 93.29 154.478 91.6387 152.44 91.6387Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3621 95.3262H33.4483C32.4295 95.3262 31.6035 96.1518 31.6035 97.1703V99.9366C31.6035 100.955 32.4295 101.781 33.4483 101.781H46.3621C47.381 101.781 48.207 100.955 48.207 99.9366V97.1703C48.207 96.1518 47.381 95.3262 46.3621 95.3262Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3279 95.3262H56.5089C55.49 95.3262 54.6641 96.1518 54.6641 97.1703V99.9366C54.6641 100.955 55.49 101.781 56.5089 101.781H94.3279C95.3467 101.781 96.1727 100.955 96.1727 99.9366V97.1703C96.1727 96.1518 95.3467 95.3262 94.3279 95.3262Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.767 95.3262H104.474C103.455 95.3262 102.629 96.1518 102.629 97.1703V99.9366C102.629 100.955 103.455 101.781 104.474 101.781H124.767C125.786 101.781 126.612 100.955 126.612 99.9366V97.1703C126.612 96.1518 125.786 95.3262 124.767 95.3262Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.982 95.3262H134.913C133.894 95.3262 133.068 96.1518 133.068 97.1703V99.9366C133.068 100.955 133.894 101.781 134.913 101.781H145.982C147.001 101.781 147.827 100.955 147.827 99.9366V97.1703C147.827 96.1518 147.001 95.3262 145.982 95.3262Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.982 78.2344H134.913C133.894 78.2344 133.068 79.06 133.068 80.0785V82.8448C133.068 83.8633 133.894 84.6889 134.913 84.6889H145.982C147.001 84.6889 147.827 83.8633 147.827 82.8448V80.0785C147.827 79.06 147.001 78.2344 145.982 78.2344Z",
    fill: "#A2CF6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.767 78.2344H104.474C103.455 78.2344 102.629 79.06 102.629 80.0785V82.8448C102.629 83.8633 103.455 84.6889 104.474 84.6889H124.767C125.786 84.6889 126.612 83.8633 126.612 82.8448V80.0785C126.612 79.06 125.786 78.2344 124.767 78.2344Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3279 78.2344H56.5089C55.49 78.2344 54.6641 79.06 54.6641 80.0785V82.8448C54.6641 83.8633 55.49 84.6889 56.5089 84.6889H94.3279C95.3467 84.6889 96.1727 83.8633 96.1727 82.8448V80.0785C96.1727 79.06 95.3467 78.2344 94.3279 78.2344Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3621 78.2344H33.4483C32.4295 78.2344 31.6035 79.06 31.6035 80.0785V82.8448C31.6035 83.8633 32.4295 84.6889 33.4483 84.6889H46.3621C47.381 84.6889 48.207 83.8633 48.207 82.8448V80.0785C48.207 79.06 47.381 78.2344 46.3621 78.2344Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.44 116.639H27.9143C25.8765 116.639 24.2246 118.29 24.2246 120.327V126.782C24.2246 128.819 25.8765 130.47 27.9143 130.47H152.44C154.478 130.47 156.13 128.819 156.13 126.782V120.327C156.13 118.29 154.478 116.639 152.44 116.639Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3621 120.326H33.4483C32.4295 120.326 31.6035 121.152 31.6035 122.17V124.937C31.6035 125.955 32.4295 126.781 33.4483 126.781H46.3621C47.381 126.781 48.207 125.955 48.207 124.937V122.17C48.207 121.152 47.381 120.326 46.3621 120.326Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3279 120.326H56.5089C55.49 120.326 54.6641 121.152 54.6641 122.17V124.937C54.6641 125.955 55.49 126.781 56.5089 126.781H94.3279C95.3467 126.781 96.1727 125.955 96.1727 124.937V122.17C96.1727 121.152 95.3467 120.326 94.3279 120.326Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.767 120.326H104.474C103.455 120.326 102.629 121.152 102.629 122.17V124.937C102.629 125.955 103.455 126.781 104.474 126.781H124.767C125.786 126.781 126.612 125.955 126.612 124.937V122.17C126.612 121.152 125.786 120.326 124.767 120.326Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.982 120.326H134.913C133.894 120.326 133.068 121.152 133.068 122.17V124.937C133.068 125.955 133.894 126.781 134.913 126.781H145.982C147.001 126.781 147.827 125.955 147.827 124.937V122.17C147.827 121.152 147.001 120.326 145.982 120.326Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.44 168.639H27.9143C25.8765 168.639 24.2246 170.29 24.2246 172.327V178.782C24.2246 180.819 25.8765 182.47 27.9143 182.47H152.44C154.478 182.47 156.13 180.819 156.13 178.782V172.327C156.13 170.29 154.478 168.639 152.44 168.639Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3621 172.326H33.4483C32.4295 172.326 31.6035 173.152 31.6035 174.17V176.937C31.6035 177.955 32.4295 178.781 33.4483 178.781H46.3621C47.381 178.781 48.207 177.955 48.207 176.937V174.17C48.207 173.152 47.381 172.326 46.3621 172.326Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3279 172.326H56.5089C55.49 172.326 54.6641 173.152 54.6641 174.17V176.937C54.6641 177.955 55.49 178.781 56.5089 178.781H94.3279C95.3467 178.781 96.1727 177.955 96.1727 176.937V174.17C96.1727 173.152 95.3467 172.326 94.3279 172.326Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.767 172.326H104.474C103.455 172.326 102.629 173.152 102.629 174.17V176.937C102.629 177.955 103.455 178.781 104.474 178.781H124.767C125.786 178.781 126.612 177.955 126.612 176.937V174.17C126.612 173.152 125.786 172.326 124.767 172.326Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.982 172.326H134.913C133.894 172.326 133.068 173.152 133.068 174.17V176.937C133.068 177.955 133.894 178.781 134.913 178.781H145.982C147.001 178.781 147.827 177.955 147.827 176.937V174.17C147.827 173.152 147.001 172.326 145.982 172.326Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.216 142.807H18.6897C16.6519 142.807 15 144.458 15 146.495V152.949C15 154.986 16.6519 156.638 18.6897 156.638H143.216C145.253 156.638 146.905 154.986 146.905 152.949V146.495C146.905 144.458 145.253 142.807 143.216 142.807Z",
    fill: "#A2CF6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1375 146.496H24.2237C23.2049 146.496 22.3789 147.322 22.3789 148.34V151.106C22.3789 152.125 23.2049 152.951 24.2237 152.951H37.1375C38.1564 152.951 38.9824 152.125 38.9824 151.106V148.34C38.9824 147.322 38.1564 146.496 37.1375 146.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1032 146.496H47.2843C46.2654 146.496 45.4395 147.322 45.4395 148.34V151.106C45.4395 152.125 46.2654 152.951 47.2843 152.951H85.1032C86.1221 152.951 86.9481 152.125 86.9481 151.106V148.34C86.9481 147.322 86.1221 146.496 85.1032 146.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.542 146.496H95.2491C94.2303 146.496 93.4043 147.322 93.4043 148.34V151.106C93.4043 152.125 94.2303 152.951 95.2491 152.951H115.542C116.561 152.951 117.387 152.125 117.387 151.106V148.34C117.387 147.322 116.561 146.496 115.542 146.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.758 146.496H125.689C124.67 146.496 123.844 147.322 123.844 148.34V151.106C123.844 152.125 124.67 152.951 125.689 152.951H136.758C137.776 152.951 138.602 152.125 138.602 151.106V148.34C138.602 147.322 137.776 146.496 136.758 146.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1598_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.474 66.2461H140.448C136.372 66.2461 133.068 69.5487 133.068 73.6227V176.895C133.068 180.969 136.372 184.272 140.448 184.272H211.474C215.549 184.272 218.853 180.969 218.853 176.895V73.6227C218.853 69.5487 215.549 66.2461 211.474 66.2461Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.561 78.2344H147.828V88.3772H198.561V78.2344Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.273 96.6758H147.828V100.714H198.273V96.6758Z",
    fill: "#A2CF6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.414 105.896H147.828V109.585H188.414V105.896Z",
    fill: "#A2CF6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.397 129.338H147.828V133.026H212.397V129.338Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.273 145.402H147.828V149.44H198.273V145.402Z",
    fill: "#A2CF6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.414 154.623H147.828V158.311H188.414V154.623Z",
    fill: "#A2CF6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.793 169.363H157.974C156.955 169.363 156.129 170.189 156.129 171.207V173.974C156.129 174.992 156.955 175.818 157.974 175.818H195.793C196.812 175.818 197.638 174.992 197.638 173.974V171.207C197.638 170.189 196.812 169.363 195.793 169.363Z",
    fill: "#A2CF6F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1598_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48C56 52.4183 52.4183 56 48 56H8C3.58172 56 0 52.4183 0 48V8Z",
    fill: "#FFFDB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2857 16H17.7143C17.2596 16 16.8236 16.1806 16.5021 16.5021C16.1806 16.8236 16 17.2596 16 17.7143V38.2857C16 38.7404 16.1806 39.1764 16.5021 39.4979C16.8236 39.8194 17.2596 40 17.7143 40H38.2857C38.7402 39.9993 39.1758 39.8185 39.4971 39.4971C39.8185 39.1758 39.9993 38.7402 40 38.2857V17.7143C40 17.2596 39.8194 16.8236 39.4979 16.5021C39.1764 16.1806 38.7404 16 38.2857 16ZM38.2857 23.7143H26.2857V17.7143H38.2857V23.7143ZM24.5714 17.7143V23.7143H17.7143V17.7143H24.5714ZM17.7143 38.2857V25.4286H38.2857L38.2874 38.2857H17.7143Z",
    fill: "#05C25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3 31.5H35V36H33.3V31.5ZM29.9 27H31.6V36H29.9V27ZM22.25 36C21.1232 35.9986 20.043 35.524 19.2463 34.6804C18.4495 33.8368 18.0013 32.693 18 31.5H19.7C19.7 32.034 19.8496 32.556 20.1298 33C20.41 33.4441 20.8082 33.7901 21.2742 33.9945C21.7401 34.1988 22.2528 34.2523 22.7475 34.1481C23.2421 34.0439 23.6965 33.7868 24.0531 33.4092C24.4097 33.0316 24.6526 32.5505 24.751 32.0267C24.8494 31.503 24.7989 30.9601 24.6059 30.4668C24.4129 29.9734 24.086 29.5517 23.6667 29.255C23.2474 28.9584 22.7543 28.8 22.25 28.8V27C23.3772 27 24.4582 27.4741 25.2552 28.318C26.0522 29.1619 26.5 30.3065 26.5 31.5C26.5 32.6935 26.0522 33.8381 25.2552 34.682C24.4582 35.5259 23.3772 36 22.25 36Z",
    fill: "#05C25E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1598_392",
    x: 33.1387,
    y: 39.5059,
    width: 163.369,
    height: 183.641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_392",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1598_392",
    x: 133.068,
    y: 66.2461,
    width: 94.7852,
    height: 127.026,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592 0 0 0 0 0.988 0 0 0 0 0.78 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_392",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1598_392",
    x: 0,
    y: 0,
    width: 65,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592 0 0 0 0 0.988 0 0 0 0 0.78 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_392",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1598_392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 224,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home_2.f22da2cc447d2e4caa91d5f424a09dff.svg";
export { ForwardRef as ReactComponent };